<div *transloco="let t" appearance="outline" class="gap-0! p-0! text-sm" tuiCardLarge>
  @let labels = labels$ | async;

  @if (labels?.length === 0) {
    @let search = search$ | async;
    <pxc-empty-state
      [description]="
        search ? t('Aucun mot clé ne correspond à votre recherche') : t('Vous n\'avez pas encore créé de mot clé.')
      "
      [icon]="search ? '@tui.search' : '@tui.tag'"
      [title]="search ? t('Aucun résultat') : t('Aucun mot clé')" />
  }

  @if (labels?.length > 0) {
    <cdk-virtual-scroll-viewport
      #viewport
      class="tui-zero-scrollbar h-[58vh] overflow-x-auto"
      tuiScrollable
      [itemSize]="56"
      [maxBufferPx]="700"
      [minBufferPx]="500">
      <table class="relative w-full" size="m" tuiTable [columns]="columns">
        <thead>
          <tr tuiThGroup>
            <th
              *tuiHead="'labelInstance.word'"
              tuiTh
              [sorter]="labelSorter"
              [sticky]="true"
              [style.top.px]="-viewport['_renderedContentOffset']">
              {{ t('Mot clé') }}
            </th>
            @if (displayStats) {
              <th
                *tuiHead="'data.subscribersCount'"
                tuiTh
                [sorter]="usersSorter"
                [sticky]="true"
                [style.top.px]="-viewport['_renderedContentOffset']">
                {{ t('Utilisé par') }}
              </th>
              <th
                *tuiHead="'userLabelStatsInstance.count'"
                tuiTh
                [sorter]="usageSorter"
                [sticky]="true"
                [style.top.px]="-viewport['_renderedContentOffset']">
                {{ t('Utilisations') }}
              </th>
            }
            <th
              *tuiHead="'createdBy'"
              tuiTh
              [sorter]="createdBySorter"
              [sticky]="true"
              [style.top.px]="-viewport['_renderedContentOffset']">
              {{ t('Créé par') }}
            </th>
            <th
              *tuiHead="'actions'"
              tuiTh
              [sorter]="null"
              [sticky]="true"
              [style.top.px]="-viewport['_renderedContentOffset']"></th>
          </tr>
        </thead>
        @let sortedLabels = labels | tuiTableSort;
        <tbody tuiTbody [data]="sortedLabels">
          <tr *cdkVirtualFor="let label of sortedLabels" class="group hover:bg-background-primary-hover" tuiTr>
            <td *tuiCell="'labelInstance.word'" class="min-w-72 max-w-72" tuiTd>
              <pxc-label [attr.data-testid]="label.labelInstance.word" [label]="label.labelInstance" />
            </td>
            @if (displayStats) {
              <td *tuiCell="'data.subscribersCount'" class="min-w-32 max-w-32" tuiTd>
                {{
                  t('{ count, plural, =1 {# utilisateur} other {# utilisateurs} }', {
                    count: label.data.subscribersCount,
                  })
                }}
              </td>
              <td *tuiCell="'userLabelStatsInstance.count'" class="min-w-32 max-w-32" tuiTd>
                {{
                  t('{ count, plural, =0 {Non utilisé} =1 {# utilisation} other {# utilisations} }', {
                    count: label.userLabelStatsInstance?.count ?? 0,
                  })
                }}
              </td>
            }
            <td *tuiCell="'createdBy'" class="min-w-44 max-w-44" tuiTd>
              <span class="block whitespace-nowrap" tuiFade>
                {{ label.createdBy | userName }}
              </span>
            </td>
            <td *tuiCell="'actions'" tuiTd>
              @if (actions?.length > 0) {
                <pxc-action-buttons
                  class="transition group-hover:opacity-100 md:opacity-0"
                  [actionButtons]="actionButtons"
                  [actions]="actions"
                  [entity]="label" />
              }
            </td>
          </tr>
        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>
  }
</div>
